import $ from 'jquery';
import { getBreakpoint } from './utils';

const siteTools = {
  dom: {
    $el: null,
    $button: null,
    $body: null,
    $keywords: null
  },
  addListeners() {
    this.dom.$button.on('click', (e) => {
      e.preventDefault();

      if(this.dom.$el.is(':visible')) {
        this.close();
      }
      else {
        this.show();
      }
    });

    // Hide site tools on mobile
    $(window).on('resize', () => {
      if (['xs', 'sm'].includes(getBreakpoint())) {
        this.close();
      }
    });
  },

  close() {
    this.dom.$button.removeClass('open');
    this.dom.$body.removeClass('site-tools-open');
    this.dom.$el.slideUp(200);
  },

  show() {
    // Showing site-tools
    this.dom.$button.addClass('open');
    this.dom.$body.addClass('site-tools-open');

    // Set focus to search field
    if(this.dom.$button.hasClass('search')) {
      setTimeout(() => {
        this.dom.$keywords.focus();
      }, 200);
    }

    this.dom.$el.slideDown(200);
  },

  init() {
    this.dom.$el = $('.site-tools');

    if(!this.dom.$el.length) {
      return;
    }
    this.dom.$body = $(document.body);
    this.dom.$button = $('.site-tools-menu');
    this.dom.$keywords = $('#keywords');

    this.addListeners();
  }
};

export default siteTools;
